export default {
      id: "icon-user-usage",
      viewBox: "0 0 16.75 21.7",
      url: __webpack_public_path__ + "Assets/Sprite.svg#icon-user",
      toString: function () {
        return this.url;
      }
    }